export enum ROLES {
  coordinator = 'coordinator',
  admin = 'admin',
  market_user = 'market_user',
}
